export default __webpack_public_path__ + "static/media/Land-Use.f1e8cb8a.png";